import React, { useEffect, useState } from 'react'
import TextField from '@mui/material/TextField';

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker, } from '@mui/x-date-pickers/DatePicker';
import { ErrorMessage, useFormikContext } from 'formik';
import moment from 'moment';
import { Input, InputBase } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { assignAddons } from '../../../Utilities/HealthInsuanceRequestBodies/ReInitializeValues/reInitializeValues';



const CustomeDatePicker = ({ field, form, productName, ...props }) => {


  const [minDate, setMinDate] = useState(null)
  const [minDateOfBirth, setMinDateOfBirth] = useState(null)

  const [maxDate, setMaxDate] = useState(null)

  const { values } = useFormikContext()
  //console.log(maxDate, "minmaxdates")

  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    'label + &': {
      marginTop: theme.spacing(3),
    },
    '& .MuiInputBase-input': {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: theme.palette.mode === 'light' ? '#fcfcfb' : '#2b2b2b',
      border: '1px solid #ced4da',
      fontSize: 16,
      width: 'auto',
      padding: '10px 12px',
      transition: theme.transitions.create([
        'border-color',
        'background-color',
        'box-shadow',
      ]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:focus': {
        boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
        borderColor: theme.palette.primary.main,
      },
    },
  }));


  const RedditTextField = styled((props) => (
    <TextField InputProps={{ disableUnderline: true }} {...props} />
  ))(({ theme }) => ({
    '& .MuiFilledInput-root': {
      border: '1px solid #e2e2e1',
      overflow: 'hidden',
      borderRadius: 4,
      backgroundColor: theme.palette.mode === 'light' ? '#fcfcfb' : '#2b2b2b',
      transition: theme.transitions.create([
        'border-color',
        'background-color',
        'box-shadow',
      ]),
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '&.Mui-focused': {
        backgroundColor: 'transparent',
        boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
        borderColor: theme.palette.primary.main,
      },
      "& label.Mui-focused": {
        display: "none"
      },
      "& legend": {
        display: "none"
      }
    },
  }));

  //console.log('sinceDate', props.arrayindex, props.previousIndex)

  //console.log('fff',field,props)

  const currentError = form.errors[field.name];
  const currentTouch = form.touched[field.name];
  useEffect(() => {

    if (field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd1_date`
      || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd2_date`
      || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd3_date`
      || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd4_date`
      || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd5_date`
      || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd6_date`
      || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd7_date`
      || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd8_date`
      || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd9_date`
      || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd10_date`
      || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd16_date`
      || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd18_date`
      || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd19_date`
      || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd20_date`
      || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd21_date`
      || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd22_date`

    ) {
      //console.log('bbb',values[`primaryDetail`][props.arrayindex]['birthDt'])
      let birthDt

      if (props.arrayindex === props.previousIndex) {
        birthDt = values[`primaryDetail`][props.arrayindex]['birthDt']

      }

      //console.log('bbb',values[`primaryDetail`][props.previousIndex]['birthDt'])
      let convertBirthDt = moment(birthDt, 'YYYY/MM/DD');
     // console.log('month', Number(convertBirthDt.format('MM')) + 1)
      let day = Number(convertBirthDt.format('DD'))
      let month = Number(convertBirthDt.format('MM'));
      let year = Number(convertBirthDt.format('YYYY'));


      let minSinceDatev = moment(`${day}-${month}-${year}`, 'DD-MM-YYYY')

      //console.log('ttt', minSinceDatev.format('DD-MM-YYYY'))

      setMinDate(minSinceDatev)

      /*  let maxdate = moment().subtract(91, "days").format("DD-MMM-YYYY");
       console.log('hhh',maxdate)
       setMaxDate(maxdate) */
    }
    
if (field.name === `dependentDetail.partyQuestionDOList[0].questionSetCd1_date`
      || field.name === `dependentDetail.partyQuestionDOList[0].questionSetCd2_date`
      || field.name === `dependentDetail.partyQuestionDOList[0].questionSetCd3_date`
      || field.name === `dependentDetail.partyQuestionDOList[0].questionSetCd4_date`
      || field.name === `dependentDetail.partyQuestionDOList[0].questionSetCd5_date`
      || field.name === `dependentDetail.partyQuestionDOList[0].questionSetCd6_date`
      || field.name === `dependentDetail.partyQuestionDOList[0].questionSetCd7_date`
      || field.name === `dependentDetail.partyQuestionDOList[0].questionSetCd8_date`
      || field.name === `dependentDetail.partyQuestionDOList[0].questionSetCd9_date`
      || field.name === `dependentDetail.partyQuestionDOList[0].questionSetCd10_date`
      || field.name === `dependentDetail.partyQuestionDOList[0].questionSetCd16_date`
      || field.name === `dependentDetail.partyQuestionDOList[0].questionSetCd18_date`
      || field.name === `dependentDetail.partyQuestionDOList[0].questionSetCd19_date`
      || field.name === `dependentDetail.partyQuestionDOList[0].questionSetCd20_date`
      || field.name === `dependentDetail.partyQuestionDOList[0].questionSetCd21_date`
      || field.name === `dependentDetail.partyQuestionDOList[0].questionSetCd22_date`

    ) {
      //console.log('bbb',values[`primaryDetail`][props.arrayindex]['birthDt'])
      let birthDt

      if (props.arrayindex === props.previousIndex) {
        birthDt = values[`dependentDetail`]['birthDt']

      }

      //console.log('bbb',values[`primaryDetail`][props.previousIndex]['birthDt'])
      let convertBirthDt = moment(birthDt, 'YYYY/MM/DD');
     // console.log('month', Number(convertBirthDt.format('MM')) + 1)
      let day = Number(convertBirthDt.format('DD'))
      let month = Number(convertBirthDt.format('MM'));
      let year = Number(convertBirthDt.format('YYYY'));


      let minSinceDatev = moment(`${day}-${month}-${year}`, 'DD-MM-YYYY')

      //console.log('ttt', minSinceDatev.format('DD-MM-YYYY'))

      setMinDate(minSinceDatev)

      /*  let maxdate = moment().subtract(91, "days").format("DD-MMM-YYYY");
       console.log('hhh',maxdate)
       setMaxDate(maxdate) */
    }


    if (field.name === `primaryDetail[${props.arrayindex}].dob`) {
      // console.log("product naam", productName)
      if(productName==="Optima Restore"){
        // do nothing
        return;
      }
      let birthDt
      let currentYear = moment()

      birthDt = localStorage.getItem(`date[${props.arrayindex}]`)
      let convertBirthDt = moment(birthDt, 'YYYY/MM/DD');
      //console.log('minnnn',birthDt)
      if (birthDt !== null) {
        let year_99 = Number(convertBirthDt.format('YYYY')) - 1
        let miniumDD = Number(convertBirthDt.format('DD')) + 2
        let minBirthDay_99 = moment(`${miniumDD}-${Number(currentYear.format('MM'))}-${year_99}`, 'DD-MM-YYYY')
        let min = moment(convertBirthDt).subtract(1, 'years').add(2, 'days').format('DD-MM-YYYY');
        //console.log('minnnnn',minBirthDay_99)
        let maxBirthDay_99 = moment(`${Number(currentYear.format('DD'))}-${Number(currentYear.format('MM'))}-${Number(convertBirthDt.format('YYYY'))}`, 'DD-MM-YYYY')
        //setMinDateOfBirth(moment(minBirthDay_99).format('DD-MM-YYYY'))
       // console.log('kk',minBirthDay_99,maxBirthDay_99,min,typeof(miniumDD))
        setMinDateOfBirth(minBirthDay_99)
        setMaxDate(maxBirthDay_99)
      }

    }
    if (field.name === `primaryDetail[${props.arrayindex}].birthDt`) {
      let birthDt
      let currentYear = moment()

      birthDt = localStorage.getItem(`date[${props.arrayindex}]`)


      let convertBirthDt = moment(birthDt, 'YYYY/MM/DD');
      //let convertBirthDt = moment(values.primaryDetail[`${props.arrayindex}`].birthDt, 'YYYY/MM/DD');

      //console.log('birthDD',convertBirthDt,values.primaryDetail[`${props.arrayindex}`].birthDt)

      if (birthDt !== null) {
        if (Number(currentYear.format('YYYY')) === Number(convertBirthDt.format('YYYY'))) {
          let past_91 = moment().subtract(91, 'days').format('DD-MM-YYYY');

          let minBirthDay_91 = moment().subtract(1, 'years').add(1, 'days')

          //  console.log('lll', minBirthDay_91)
          past_91 = moment(past_91, 'DD-MM-YYYY')


          setMinDateOfBirth(minBirthDay_91)
          setMaxDate(past_91)

        } else {

          let year_99 = Number(convertBirthDt.format('YYYY')) - 1
          let miniumDD = Number(convertBirthDt.format('DD')) + 2
          let minBirthDay_99 = moment(`${miniumDD}-${Number(currentYear.format('MM'))}-${year_99}`, 'DD-MM-YYYY')
          let min = moment(convertBirthDt).subtract(1, 'years').add(2, 'days').format('DD-MM-YYYY');
          //console.log('minnnnn',min)
          let maxBirthDay_99 = moment(`${Number(currentYear.format('DD'))}-${Number(currentYear.format('MM'))}-${Number(convertBirthDt.format('YYYY'))}`, 'DD-MM-YYYY')
          //setMinDateOfBirth(moment(minBirthDay_99).format('DD-MM-YYYY'))
          //console.log('kk',minBirthDay_99,maxBirthDay_99,min,typeof(miniumDD))
          setMinDateOfBirth(minBirthDay_99)
          setMaxDate(maxBirthDay_99)
        }
      }








    }

  }, [values])

  // useEffect(() => {
  //   if (field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd1_date`
  //     || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd2_date`
  //     || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd3_date`
  //     || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd4_date`
  //     || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd5_date`
  //     || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd6_date`
  //     || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd7_date`
  //     || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd8_date`
  //     || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd9_date`
  //     || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd10_date`
  //     || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd16_date`
  //     || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd18_date`
  //     || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd19_date`
  //     || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd20_date`
  //     || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd21_date`
  //     || field.name === `primaryDetail[${props.arrayindex}].partyQuestionDOList[0].questionSetCd22_date`

  //   ) {
  //     //console.log('bbb',values[`primaryDetail`][props.arrayindex]['birthDt'])
  //     let birthDt
  //     console.log(props.arrayindex, props.previousIndex,"indexes....")      
  //     if (props.arrayindex === props.previousIndex) {
  //       birthDt = values[`primaryDetail`][props.arrayindex]['birthDt']

  //     }

  //     //console.log('bbb',values[`primaryDetail`][props.previousIndex]['birthDt'])
  //     let convertBirthDt = moment(birthDt, 'YYYY/MM/DD');
  //     console.log('month', Number(convertBirthDt.format('MM')) + 1)
  //     let day = Number(convertBirthDt.format('DD'))
  //     let month = Number(convertBirthDt.format('MM'));
  //     let year = Number(convertBirthDt.format('YYYY'));


  //     let minSinceDatev = moment(`${day}-${month}-${year}`, 'DD-MM-YYYY')

  //     console.log('ttt', minSinceDatev.format('DD-MMM-YYYY'))

  //     setMinDate(minSinceDatev)

  //     /*  let maxdate = moment().subtract(91, "days").format("DD-MMM-YYYY");
  //      console.log('hhh',maxdate)
  //      setMaxDate(maxdate) */
  //   }

  //   if(field.name === `primaryDetail[${props.arrayindex}].birthDt`){
  //     let birthDt

  //       birthDt = values[`primaryDetail`][props.arrayindex]['birthDt']

  //     console.log('bbb',values[`primaryDetail`][props.arrayindex]['birthDt'])
  //     let convertBirthDt = moment(birthDt, 'YYYY/MM/DD');
  //     console.log('mmm', Math.ceil((Number(convertBirthDt.format('MM')) + 10)/12)+10)
  //     let day = Number(convertBirthDt.format('DD')) +30;
  //     let month = Number(convertBirthDt.format('MM')) +11
  //     let year = Number(convertBirthDt.format('YYYY'));


  //     let minSinceDatev = moment(`${day}-${month}-${year}`, 'DD-MM-YYYY')
  //     console.log('max', minSinceDatev.format('DD-MM-YYYY'))
  //     setMaxDate(minSinceDatev)
  //   }



  // }, [values])

  //let maxxDate = maxDate ? maxDate : moment(localStorage.getItem("date"))
  //console.log(moment(localStorage.getItem("date")), "maxxDate...")
  console.log('dateP',field)
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <MobileDatePicker
        disableFuture
        id={field.name}
        value={field.value}
        //minDate={minDate}
        minDate={field.name === `primaryDetail[${props.arrayindex}].birthDt`|| 
        field.name ===`primaryDetail[${props.arrayindex}].dob` ? minDateOfBirth : minDate}
        //maxDate={maxDate ? maxDate : moment(localStorage.getItem("date"), 'DD-MM-YYYY')}
        maxDate={field.name === `primaryDetail[${props.arrayindex}].birthDt`|| 
        field.name === `primaryDetail[${props.arrayindex}].dob` ? maxDate : null}
        inputFormat="DD-MMMM-YYYY"

        name={field.name}
        touched={Boolean(currentTouch)}
        {...field}
        // InputLabelProps={{ shrink: true }}
        {...form}
        //{...props}
        onChange={(newValue) => {
          //console.log('hdhhdh',moment(newValue).format("DD-MMM-YYYY"))


          if (field.name === `primaryDetail[${props.previousIndex}].birthDt`) {
            if (moment().diff(newValue, 'days') > 91) {
              //console.log('yes greater')
              form.setFieldValue(field.name, moment(newValue).format("YYYY-MM-DD"))
            } else {
              form.setFieldError(field.name, 'Age should be more than 91 days');
              form.setFieldValue(field.name, '')


            }
          } else {
            form.setFieldValue(field.name, moment(newValue).format("YYYY-MM-DD"))
          }


          //form.setFieldValue("dependentDetail.addOns",assignAddons(newValue))
        }}
        onAccept={(value)=> {
          const { arrayindex } = props;
          // console.log("arrayindex", arrayindex)
          // filling age field value after calculating dob field value
          if(field.name===`primaryDetail[${arrayindex}].dob`){
            let dob = new Date(value);
            let diff = Date.now() - dob;
            let ageInDate = new Date(diff);
            let ageInYear = Math.abs(ageInDate.getUTCFullYear() - 1970);
            // console.log("ageInYear", ageInYear);
            form.setFieldValue(`primaryDetail[${arrayindex}].age`, ageInYear);
            form.setFieldValue(`medicalQuestions[${arrayindex}].dob`, moment(value).format("YYYY-MM-DD"));
          } else if(field.name===`dependentDetail.dob`) {
            let dob = new Date(value);
            let diff = Date.now() - dob;
            let ageInDate = new Date(diff);
            let ageInYear = Math.abs(ageInDate.getUTCFullYear() - 1970);
            // console.log("ageInYear", ageInYear);
            form.setFieldValue("dependentDetail.age", ageInYear);
          }
        }}

        renderInput={(params) => {
          //console.log('param',params)
          return (

            <TextField
              //touched={form.touched}
              name={field.name}
              id={field.name}
              sx={{
                /* "& label.Mui-focused": {
                  display: "none"
                }, */

                "& legend": {
                  display: "none"
                },
                '& .MuiOutlinedInput-root': {

                  "&.Mui-error fieldset ": {
                    borderColor: "rgba(0, 0, 0, 0.23) !important"  // default
                  },



                },


              }}
              //error={Boolean(currentError)}

              fullWidth
              {...params} />
          )
        }}
      />

    </LocalizationProvider>
  )
}

export default CustomeDatePicker